// extracted by mini-css-extract-plugin
export default {"chatMsgArea":"chat-msg-area_chatMsgArea__QNZmC","warnMsg":"chat-msg-area_warnMsg__zBZ+H","errMsg":"chat-msg-area_errMsg__J8TTU"};